import { z } from 'zod';
import { API_CONFIG } from './api';
import { apiClient } from '../lib/apiClient';
import { logger } from '../utils/logger';
import { apiResponseSchema, oauthConfigSchema } from '../lib/schemas';

type OAuthConfig = z.infer<typeof oauthConfigSchema>;

let oauthConfigCache: OAuthConfig | null = null;
let cacheExpiry: number = 0;
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

export async function getOAuthConfig(): Promise<OAuthConfig> {
  const now = Date.now();

  if (oauthConfigCache && now < cacheExpiry) {
    logger.debug('[OAuthConfig] Using cached OAuth configuration');
    return oauthConfigCache;
  }

  try {
    logger.debug('[OAuthConfig] Fetching OAuth configuration from backend');
    const response = await apiClient.get(
      `${API_CONFIG.apiVersion}/config/oauth`,
      {
        validate: apiResponseSchema(oauthConfigSchema),
        deduplicate: true,
        context: 'OAuthConfig',
      }
    );

    oauthConfigCache = response.data;
    cacheExpiry = now + CACHE_TTL;
    logger.debug('[OAuthConfig] OAuth configuration cached');

    return oauthConfigCache;
  } catch (error) {
    logger.error('[OAuthConfig] Failed to fetch OAuth configuration:', error);
    throw error;
  }
}

export function clearOAuthConfigCache(): void {
  oauthConfigCache = null;
  cacheExpiry = 0;
  logger.debug('[OAuthConfig] Cache cleared');
}

